const translations: Record<string, string> = {
  "ak_bud2_incl_bess_effect_mn": "incl. BESS effect {{v}} mn",
  "ak_bud2_segment_width_is_the_share_of_the_mont": "Segment width is the share of the month revenue; deductions start where the previous balance ended.",
  "ak_bud2_break_even_revenue_mn_break_even_price": "Break-even revenue {{a}} mn · Break-even price BASE {{b}} UAH/MWh",
  "ak_bud2_mn_of_mn": "{{a}} mn of {{b}} mn",
  "ak_bud2_folded_by_hour_of_day": "{{m}} · folded by hour of day",
  "ak_bud2_uah_mwh": "UAH/MWh",
  "ak_bud2_plan_release": "Plan release",
  "ak_bud2_mwh": "{{v}} MWh",
  "ak_bud2_uah_mwh_2": "{{v}} UAH/MWh",
  "ak_bud2_metric_hour": "Metric \\ Hour",
  "ak_bud2_clock_hour": "Clock hour:",
  "ak_bud2_monthly_averages": "— monthly averages;",
  "ak_bud2_totals": "— totals",
  "ak_bud2_for_of_days_that_have_an_hourly_plan": " for {{p}} of {{m}} days that have an hourly plan",
  "ak_bud2_so_total_differs_from_the_monthly_p_l": "so “Total” differs from the monthly P&L plan ({{mwh}} MWh / {{rev}} UAH mn)",
  "ak_bud2_so_total_differs_from_the_monthly_p_l_2": "so “Total” differs from the monthly P&L plan ({{mwh}} MWh)",
  "ak_bud2_there_is_no_approved_budget_version_fo": "There is no approved budget version for this month.",
  "ak_bud2_uah_mn": "UAH mn",
  "ak_bud2_revenue": "Revenue",
  "ak_bud2_variable_costs": "Variable costs",
  "ak_bud2_fixed_opex": "Fixed OPEX",
  "ak_bud2_finance_costs": "Finance costs",
  "ak_bud2_income_tax": "Income tax",
  "ak_bud2_net_profit": "Net profit",
  "ak_bud2_loan_principal_repayment": "Loan principal repayment",
  "ak_bud2_supplier_margin_3_imbalances_2_5": "supplier margin 3% + imbalances 2.5%",
  "ak_bud2_interest_fee_account_servicing": "interest + fee + account servicing",
  "ak_bud2_cash_flow_after_repayment": "Cash flow after repayment",
  "ak_bud2_month_with_a_principal_payment_covered": "month with a principal payment — covered by the accumulated flow",
  "ak_bud2_from_revenue_to_cash_flow": "From revenue to cash flow",
  "ak_bud2_profitability_and_margin": "Profitability and margin",
  "ak_bud2_ebitda_margin": "EBITDA margin",
  "ak_bud2_net_margin": "Net margin",
  "ak_bud2_safety_margin": "Safety margin",
  "ak_bud2_bess_share_of_revenue": "BESS share of revenue",
  "ak_bud2_source_monthly_slice_of_the_approved_a": "Source: monthly slice of the approved annual budget. The month’s own version recalculated for T−5/T−1 is produced by the engine (Ph3).",
  "ak_bud2_source_approved_version_of_the_monthly": "Source: approved version of the monthly budget.",
  "ak_bud2_daily_profile_prices_and_release_plan": "Daily profile: prices and release plan",
  "ak_bud2_there_is_no_hourly_forecast_for_this_m": "There is no hourly forecast for this month in the database.",
  "ak_bud2_dam_price_forecast": "DAM price (forecast)",
  "ak_bud2_idm_price_forecast": "IDM price (forecast)",
  "ak_bud2_total": "Total",
  "ak_bud2_dam_price_uah_mwh": "DAM price, UAH/MWh",
  "ak_bud2_idm_price_uah_mwh": "IDM price, UAH/MWh",
  "ak_bud2_plan_release_mwh": "Plan release, MWh",
  "ak_bud2_bess_charge_mwh": "BESS charge, MWh",
  "ak_bud2_bess_discharge_mwh": "BESS discharge, MWh",
  "ak_bud2_plan_revenue_uah_k": "Plan revenue, UAH k",
  "ak_bud2_mwh_2": "MWh",
  "ak_bud2_dam_price": "DAM price",
  "ak_bud2_idm_price": "IDM price",
  "ak_bud2_prices": "Prices",
  "ak_bud2_total_weighted_by_release_release_pric": " “Total” = weighted by release (release × price = revenue)",
  "ak_bud2_total_simple_daily_average_as_there_is": " “Total” = simple daily average, as there is no release plan to weight by",
  "ak_bud2_volumes_and_revenue": "Volumes and revenue",
  "ak_bud2_for_the_month": " for the month",
  "ak_bud2_there_is_no_hourly_release_plan_for_th": "there is no hourly release plan for this month yet — model M1 will provide it",
  "ak_bud2_comparable_both_plan_and_actual": "Comparable (both plan and actual):",
  "ak_bud2_days": "days,",
  "ak_bud2_plan": "plan",
  "ak_bud2_actual": "actual",
  "ak_bud2_total_of_actuals_across_all": "“Total” of actuals — across all",
  "ak_bud2_days_with_actuals": "days with actuals",
  "ak_bud2_below_20_a_reason_from_the_dispatcher": "below −20%: {{days}} — a reason from the dispatcher is required",
  "ak_bud2_target": "target {{t}}",
  "ak_bud2_horizon_days": "horizon {{h}} · {{d}} days",
  "ak_bud2_profile_correlation_and_nmae_are_calcu": "Profile correlation {{c}} and nMAE {{n}} are calculated against the nomination — {{note}}. Only the daily metrics above are meaningful for assessing the model.",
  "ak_bud2_base_uah_mwh": "BASE {{v}} UAH/MWh",
  "ak_bud2_dip_11_16_forecast_actual": "“Dip” 11–16: forecast {{p}} → actual {{f}} ({{e}})",
  "ak_bud2_peak_18_23_forecast_actual": "“Peak” 18–23: forecast {{p}} → actual {{f}} ({{e}})",
  "ak_bud2_hours_volume_price_profile": "{{h}} hours · volume × price × profile",
  "ak_bud2_mn": "{{v}} mn",
  "ak_bud2_mwh_uah_weighted": "{{a}} MWh × {{b}} UAH (weighted)",
  "ak_bud2_days_channel_a_export": "{{d}} days · channel A− (export)",
  "ak_bud2_pv_generation_ktp_meters": "PV generation ({{n}} KTP meters)",
  "ak_bud2_bess_discharge_meters": "BESS discharge ({{n}} meters)",
  "ak_bud2_is_assumed_in_the_calculations": "{{v}} is assumed in the calculations",
  "ak_bud2_channel_a_import_is_absent_from_the_ex": "Channel A+ (import) is absent from the export, so the net charge is not measured. The true coefficient is LOWER than the limit shown — the residual also contains auxiliary consumption and losses.",
  "ak_bud2_plan_actual_mwh": "plan {{a}} → actual {{f}} MWh",
  "ak_bud2_definition_of_actuals": "Definition of actuals: {{d}}",
  "ak_bud2_plan_vs_actual_by_day": "Plan vs actual by day",
  "ak_bud2_plan_accepted_mms_nomination_actual_gr": "plan — accepted MMS nomination · actual — grid export",
  "ak_bud2_no_data_for_this_month": "No data for this month.",
  "ak_bud2_mms_plan_mwh": "MMS plan, MWh",
  "ak_bud2_actual_export_mwh": "Actual export, MWh",
  "ak_bud2_deviation": "Deviation, %",
  "ak_bud2_dam_price_actual_uah_mwh": "DAM price actual, UAH/MWh",
  "ak_bud2_actual_revenue_uah_k": "Actual revenue, UAH k",
  "ak_bud2_x": "Δ, %",
  "ak_bud2_deviation_2": "Deviation",
  "ak_bud2_mms_plan": "MMS plan",
  "ak_bud2_actual_2": "Actual",
  "ak_bud2_actual_export": "Actual export",
  "ak_bud2_metric_day": "Metric \\ Day",
  "ak_bud2_spec_thresholds_5_5_20_below_20": "spec thresholds: 🟢 ≥ −5% · 🟡 −5…−20% · ⚠ below −20%",
  "ak_bud2_there_are_no_forecast_actual_pairs_for": "There are no “forecast — actual” pairs for this month to calculate accuracy.",
  "ak_bud2_generation_forecast_accuracy": "Generation forecast accuracy",
  "ak_bud2_hit_rate_10_tolerance": "Hit rate (10% tolerance)",
  "ak_bud2_bias": "Bias",
  "ak_bud2_systematic_over_under_estimation": "systematic over/under-estimation",
  "ak_bud2_price_forecast_accuracy": "Price forecast accuracy",
  "ak_bud2_hit_rate_15_tolerance": "Hit rate (15% tolerance)",
  "ak_bud2_nmae_vs_base": "nMAE (vs BASE)",
  "ak_bud2_profile_correlation": "Profile correlation",
  "ak_bud2_revenue_difference_breakdown": "Revenue difference breakdown",
  "ak_bud2_revenue_per_plan": "Revenue per plan",
  "ak_bud2_revenue_per_actual": "Revenue per actual",
  "ak_bud2_difference": "Difference",
  "ak_bud2_volume_effect": "Volume effect",
  "ak_bud2_profile_effect": "Profile effect",
  "ak_bud2_price_effect": "Price effect",
  "ak_bud2_actual_plan_weighted_plan_price": "(actual − plan) × weighted plan price",
  "ak_bud2_shifting_export_to_other_hours_the_mon": "shifting export to other hours — the monetary effect of BESS",
  "ak_bud2_market_deviation_from_the_forecast": "market deviation from the forecast",
  "ak_bud2_bess_charge_for_the_month": "BESS charge for the month",
  "ak_bud2_bess_discharge_for_the_month": "BESS discharge for the month",
  "ak_bud2_this_shift_is_what_produces_the_profil": "this shift is what produces the profile effect",
  "ak_bud2_breakdown_residual": "Breakdown residual",
  "ak_bud2_check_sum_of_the_three_effects_revenue": "check: sum of the three effects = revenue difference",
  "ak_bud2_balance_by_askoe_meters": "Balance by ASKOE meters",
  "ak_bud2_grid_export_commercial_110_kv": "Grid export (commercial 110 kV)",
  "ak_bud2_this_is_the_revenue_basis": "this is the revenue basis",
  "ak_bud2_backup_meter": "Backup meter",
  "ak_bud2_deviation_from_the_main_meter_should_b": "deviation from the main meter should be within 1%",
  "ak_bud2_verification_10_kv": "Verification 10 kV",
  "ak_bud2_balance_residual": "Balance residual",
  "ak_bud2_bess_charge_auxiliary_consumption_loss": "BESS charge + auxiliary consumption + losses",
  "ak_bud2_charge_coefficient_upper_limit": "Charge coefficient, upper limit",
  "ak_bud2_days_with_the_largest_generation_forec": "Days with the largest generation forecast error",
  "ak_bud2_top_5_by_absolute_deviation": "top 5 by absolute deviation",
  "ak_bud2_first_three_months_observation_then_th": "first three months — observation, then the targets become KPIs for the forecast contractors",
  "ak_bud2_mms_nomination": "MMS nomination",
  "ak_bud2_engine_plan": "engine plan",
  "ak_bud2_failed_to_save_http": "Failed to save: HTTP {{s}}",
  "ak_bud2_failed_http": "Failed: HTTP {{s}}",
  "ak_bud2_source": "source: {{s}}",
  "ak_bud2_buffer_mn_large_loan_principal": "buffer {{b}} mn (large loan principal)",
  "ak_bud2_buffer_mn": "buffer {{b}} mn",
  "ak_bud2_without_an_opening_balance_the_cash_fo": "Without an opening balance the cash forecast is not calculated. There is no statement — enter the balance as of {{d}} manually:",
  "ak_bud2_save": "Save",
  "ak_bud2_forecast_balance_falls_below_the_buffe": "Forecast balance falls below the buffer of {{b}} mn:",
  "ak_bud2_mn_2": "{{d}} → {{v}} mn",
  "ak_bud2_treasurer_decision_required_postpone_t": "Treasurer decision required: postpone the payment, overdraft or early sale.",
  "ak_bud2_items": "{{n}} items · {{m}}",
  "ak_bud2_receipts_by_the_ten_day_rule_1_10_15th": "Receipts — by the ten-day rule (1–10 → 15th, 11–20 → 25th, 21–end → 5th of the next month), net of the supplier margin.",
  "ak_bud2_payment_days_of_the_fixed_items_are_no": "Payment days of the fixed items are not filled in the directory — day {{d}} of the month is assumed; this is an assumption, not data (spec A7).",
  "ak_bud2_rows_to_confirm_unmatched": "{{n}} rows · to confirm {{c}} · unmatched {{u}}",
  "ak_bud2_no_statements_ingest_is_implemented_fo": "No statements. Ingest is implemented for CSV",
  "ak_bud2_with_protection_against_re_upload_and": "with protection against re-upload and rule-based auto-matching.",
  "ak_bud2_it_is_adapted_to_the_real_bank_format": "It is adapted to the real bank format (CSV / XML / MT940) by replacing the parser — the format itself and the way to obtain it are needed.",
  "ak_bud2_spec_b5_1_thresholds_confidence_0_90_a": "Spec B5.1 thresholds: confidence ≥ 0.90 — automatic, 0.60–0.90 — to confirm, below — unmatched. A currency purchase pair is folded into a single bank payment event and always goes to the treasurer for confirmation together with the actual rate.",
  "ak_bud2_table": "Table",
  "ak_bud2_and_the_matching_chain_are_ready_the_e": "and the matching chain are ready; the export from the accounting system is missing — it is marked in the spec as “BAS / 1C — to be clarified”.",
  "ak_bud2_enter_the_opening_balance_amount": "Enter the opening balance amount",
  "ak_bud2_failed_to_save_the_opening_balance": "Failed to save the opening balance",
  "ak_bud2_failed_to_update_the_matching": "Failed to update the matching",
  "ak_bud2_opening_balance": "Opening balance",
  "ak_bud2_no_statement_and_no_manual_value": "no statement and no manual value",
  "ak_bud2_receipts": "Receipts",
  "ak_bud2_by_ten_day_periods_minus_margin": "by ten-day periods, minus margin",
  "ak_bud2_payments": "Payments",
  "ak_bud2_loan_opex_imbalances": "loan, OPEX, imbalances",
  "ak_bud2_net_for_the_month": "Net for the month",
  "ak_bud2_end_of_month": "End of month",
  "ak_bud2_mn_3": "mn",
  "ak_bud2_uah": "UAH",
  "ak_bud2_payment_calendar": "Payment calendar",
  "ak_bud2_date": "Date",
  "ak_bud2_item": "Item",
  "ak_bud2_amount_uah": "Amount, UAH",
  "ak_bud2_balance_after": "Balance after",
  "ak_bud2_basis": "Basis",
  "ak_bud2_payment_day_assumed": "payment day assumed",
  "ak_bud2_bank_operations_and_matching": "Bank operations and matching",
  "ak_bud2_no_statements_uploaded_yet": "no statements uploaded yet",
  "ak_bud2_counterparty": "Counterparty",
  "ak_bud2_purpose": "Purpose",
  "ak_bud2_conf": "Conf.",
  "ak_bud2_status": "Status",
  "ak_bud2_automatic": "automatic",
  "ak_bud2_to_confirm": "to confirm",
  "ak_bud2_confirmed": "confirmed",
  "ak_bud2_rejected": "rejected",
  "ak_bud2_unmatched": "unmatched",
  "ak_bud2_confirm_the_match": "Confirm the match",
  "ak_bud2_confirm": "Confirm",
  "ak_bud2_reject_the_match": "Reject the match",
  "ak_bud2_reject": "Reject",
  "ak_bud2_accounts_payable": "Accounts payable",
  "ak_bud2_awaiting_access_to_accounting": "awaiting access to accounting",
  "ak_bud2_accrued_per_acts_versus_paid_per_state": "Accrued per acts versus paid per statements, by counterparty and contract.",
};

export default translations;
